<div class="meus-orcamentos">
  <div class="container">
    <div class='row'>
      <div class='col text-center mobile-h5'>
        <h5 class="title">{{'Meus Orçamentos' | translate}} </h5>
      </div>
    </div>
    <div class="content">
      <div class="leftDiv">
        <h5 class="h5-mobile">{{"Buscar Orçamentos" | translate}}</h5>
        <div class="row">
          <div class='col'>
            <span class="input-group-text" id="inputGroup-sizing-default">{{'Nome' | translate}} PAX</span>
            <input [(ngModel)]="filtro.pax" type="text" [placeholder]="'Nome' | translate" class="form-control"
              aria-label="Default" aria-describedby="inputGroup-sizing-default">
          </div>
        </div>
        <div class="row">
          <div class="mobile-div">
            <div class="col mobile-left">
              <div class="mb-2">
                <mat-form-field class="datepicker col-md-12 p-0" style="padding: 0 !important;" appearance="fill">
                  <span class="input-group-text" id="inputGroup-sizing-default">{{"De" | translate}}</span>
                  <input matInput [matDatepicker]="picker" [(ngModel)]="dataDe" name="data1"
                    (keypress)="permitirSomenteDatas($event)" (input)="formatarDataManual($event)" [max]="maxData"
                    (keydown)="limpar($event)" maxlength="10" autocomplete="off" required />
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
              </div>
            </div>
            <div class="col mobile-right">
              <div class="">
                <mat-form-field class="datepicker col-md-12" appearance="fill">
                  <span class="input-group-text" id="inputGroup-sizing-default">{{"Até" | translate}}</span>
                  <input matInput [matDatepicker]="pickerAte" [(ngModel)]="dataAte" name="data2"
                    (keypress)="permitirSomenteDatas($event)" [max]="maxData" [min]="dataDe"
                    (input)="formatarDataManual($event)" (keydown)="limpar($event)" maxlength="10" autocomplete="off"
                    required />
                  <mat-datepicker-toggle matSuffix [for]="pickerAte"></mat-datepicker-toggle>
                  <mat-datepicker #pickerAte></mat-datepicker>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
        <div class="mobile-div">
          <div class="row mobile-left mobile-input">
            <span class="input-group-text" id="inputGroup-sizing-default">{{"Número do Orçamento" | translate}}</span>
            <input [(ngModel)]="filtro.id" type="number" min="0" [placeholder]="'Número do Orçamento' | translate"
              class="form-control" aria-label="Default" aria-describedby="inputGroup-sizing-default">
          </div>
          <div class="row mobile-right">
            <span class="input-group-text mobile-span" id="inputGroup-sizing-default">{{"Localizador" | translate
              }}</span>
            <input [(ngModel)]="filtro.localizador" type="text" min="0" placeholder="{{'Localizador' | translate}}"
              class="form-control" aria-label="Default" aria-describedby="inputGroup-sizing-default">
          </div>
        </div>
        <div class="row">
          <span class="input-group-text" id="inputGroup-sizing-default">{{'Status da Reserva' | translate}}</span>
          <select [(ngModel)]="filtro.situacao" class="custom-select form-select" id="inputGroupSelect01">
            <option value="0">{{"Pendente" | translate}}</option>
            <option value="1">{{"Pré-Pagamento" | translate }}</option>
            <option value="6">{{"Pago" | translate}}</option>
            <option value="">{{"Todos" | translate}}</option>
          </select>

        </div>

        <div style="display:none;" class="row">
          <span class="input-group-text" id="inputGroup-sizing-default">{{'Agência' | translate}}</span>
          <input type="text" class="form-control" aria-label="Default" aria-describedby="inputGroup-sizing-default">
        </div>
        <div class="row">
          <button (click)="buscarMeusOrcamentos()" type="button" class="btn btn-success">{{'Filtrar' |
            translate}}</button>
          <button (click)="limparFiltro()" type="button" class="mt-3 btn btn-danger">{{'Limpar Filtro' |
            translate}}</button>
        </div>
      </div>
      <div class="rightDiv">
        <app-view-loading *ngIf="carregando"></app-view-loading>
        <div *ngIf="!carregando">
          <div class="mt-3">
            <h6 class="mb-2">Legenda de Status:</h6>
            <span class="text-muted">Status referente apenas a um dos itens referenciados.</span>
            <ul class="list-unstyled d-flex flex-wrap column-gap-3">
              <li><i class="fa fa-circle text-muted me-1"></i>Pendente</li>
              <li><i class="fa fa-circle text-primary me-1"></i>Aguardando</li>
              <li><i class="fa fa-circle text-info me-1"></i>Reserva Parcial</li>
              <li><i class="fa fa-circle text-success me-1"></i>Reservado/Solicitado/Emitido/Pago</li>
              <li><i class="fa fa-circle text-danger me-1"></i>Problema Técnico</li>
              <li><i class="fa fa-circle text-warning me-1"></i>Cancelado</li>
              <!-- <li><i class="fa fa-circle text-secondary  me-1"></i>Excluído</li> -->
            </ul>
          </div>
          <div class="table-responsive">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th scope="col" class="numero">{{'Número' | translate}}</th>
                  <th scope="col" class="pax">Pax</th>
                  <th scope="col" class="data">{{'Data' | translate}}</th>
                  <th scope="col" class="agente">{{'Agente' | translate}}</th>
                  <th scope="col" class="agencia">{{'Agência' | translate}}</th>
                  <th scope="col" class="itens">{{'Itens' | translate}}</th>
                  <th scope="col" class="status">{{"Status" | translate}}</th>
                  <!-- <th scope="col" class="localizador">Localizador</th> -->
                </tr>
              </thead>
              <tbody *ngFor="let reserva of orcamentos; let a = index">
                <tr>
                  <th scope="row" class="numero" (click)="acessarOrcamento($event, reserva)"> {{reserva.Id}}
                  </th>
                  <td class="pax"> {{reserva.Pax}}</td>
                  <td class="data">{{reserva.Alteracoes.CriadoEm | date: 'dd/MM/yyyy HH:mm' }}</td>
                  <td class="agente">{{reserva.Agente?.Nome}}</td>
                  <td class="agencia">{{reserva.Agencia?.NomeFantasia}}</td>
                  <td class="itens">
                    <span *ngIf="reserva.Hoteis?.length > 0">
                      <i *ngIf="reserva.Hoteis[0].PacoteId != (null||undefined)" class="fa fa-star"
                        (click)="abrirModal(mostraPacote, reserva)" title="Pacotes"></i>
                    </span>
                    <i *ngIf="reserva.Aereos?.length > 0" class="fa fa-plane fa-rotate-270"
                      [ngClass]="getStatusClass(reserva.Aereos)" (click)="abrirModal(mostraAereo, reserva)"
                      title="Aéreos"></i>
                    <i *ngIf="reserva.Hoteis?.length > 0" (click)="abrirModal(mostrarHotel, reserva)" class="fa fa-hotel"
                      title="Hoteis" [ngClass]="getStatusClass(reserva.Hoteis)"></i>
                    <i *ngIf="reserva.Servicos?.length > 0" class="fa fa-bus"
                      (click)="abrirModal(mostraServico, reserva)" title="Tranfers "
                      [ngClass]="getStatusClass(reserva.Servicos)"></i>
                    <i *ngIf="reserva.Tickets?.length > 0" class="fa fa-bus" (click)="abrirModal(mostraServico, reserva)"
                      title="Tranfers " [ngClass]="getStatusClass(reserva.Tickets)"></i>
                    <i *ngIf="reserva.Tours?.length > 0" class="fa fa-ticket"
                      (click)="abrirModal(mostraServico, reserva)" title="Tickets "
                      [ngClass]="getStatusClass(reserva.Tours)"></i>
                    <i *ngIf="reserva.Carros?.length > 0" class="fa fa-car " title="Carros "
                      [ngClass]="getStatusClass(reserva.Carros)"></i>
                    <i *ngIf="reserva.Seguros?.length > 0" class="fa fa-shield-alt" title="Seguros "
                      [ngClass]="getStatusClass(reserva.Seguros)"></i>
                    <i *ngIf="reserva.BetoCarreroIngressos?.length > 0" class="fa fa-hat-cowboy-side"
                      title="Beto Carrero " (click)="abrirModal(mostraBetoCarrero, reserva)" [ngClass]="getStatusClass(reserva.BetoCarreroIngressos)"></i>
                    <!-- <i *ngIf="reserva.Pacote.length > 0" class="fa fa-star" title="Pacote"></i> -->
                  </td>
                  <td [ngSwitch]="reserva.Status">
                    <span *ngSwitchCase="0">{{'Pendente' | translate}}</span>
                    <span *ngSwitchCase="1">{{'Aguardando' | translate}}</span>
                    <span *ngSwitchCase="2">{{'Reserva Parcial' | translate}}</span>
                    <span *ngSwitchCase="3">{{'Reservado' | translate}}</span>
                    <span *ngSwitchCase="4">{{'Solicitado' | translate}}</span>
                    <span *ngSwitchCase="5">{{'Emitido' | translate}}</span>
                    <span *ngSwitchCase="6">{{'Pago' | translate}}</span>
                    <span *ngSwitchCase="7">{{'Problema Técnico' | translate}}</span>
                    <span *ngSwitchCase="8">{{'Cancelado' | translate}}</span>
                    <span *ngSwitchCase="9">{{'Excluído' | translate}}</span>
                    <span *ngSwitchCase="10">{{'Cancelamento com Problema' | translate}}</span>
                  </td>
                  <!-- <td class="localizador">{{reserva.Localizador}}</td> -->
                </tr>

              </tbody>
            </table>
            <app-paginacao [paginacao]="paginacao" (alterarPagina)="buscarPagina($event)"></app-paginacao>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template let-modal #mostrarHotel>
  <div class="row">
    <div class="modal-header px-3 col-12 d-flex align-items-center">
      <h5 class="text-center">{{'Hoteis' | translate}}</h5>
      <i class="ms-auto me-3 fa fa-times" style="cursor: pointer;" (click)="fecharModal()"></i>
    </div>
    <div class="col-12 modal-body px-5 py-3">
      <ng-container *ngFor="let hotel of itemParaVisualizacao.Hoteis; let last = last; let index = index">
        <h5>Hotel {{index + 1}}</h5>
        <app-hotel-card [hotelId]="hotel.Id" [cardSimplificado]="true" [cardItem]="hotel"></app-hotel-card>
        <hr *ngIf="!last" class="w-100 my-3 bg-secondary">
      </ng-container>
    </div>
  </div>
</ng-template>

<ng-template let-modal #mostraAereo>
  <div class="row">
    <div class="modal-header px-3 col-12 d-flex align-items-center">
      <h5 class="text-center">{{'Aéreos' | translate}}</h5>
      <i class="ms-auto me-3 fa fa-times" style="cursor: pointer;" (click)="fecharModal()"></i>
    </div>
    <div class="col-12 modal-body px-5 py-3">
      <ng-container *ngFor="let aereo of itemParaVisualizacao.Aereos; let last = last; let index = index">
        <h5>Aereo {{index + 1}}</h5>
        <app-aereo-card [executarGetAereo]="false" [cardItem]="aereo" [aereo]="aereo" [cardSimplificado]="true"></app-aereo-card>
        <hr *ngIf="!last" class="w-100 my-3 bg-secondary">
      </ng-container>
    </div>
  </div>
</ng-template>

<ng-template let-modal #mostraServico>
  <div class="row">
    <div class="modal-header px-3 col-12 d-flex align-items-center">
      <h5 class="text-center">{{'Serviços' | translate}}</h5>
      <i class="ms-auto me-3 fa fa-times" style="cursor: pointer;" (click)="fecharModal()"></i>
    </div>
    <div class="col-12 modal-body px-5 py-3">
      <ng-container *ngFor="let servico of itemParaVisualizacao.Servicos; let last = last; let index = index">
        <app-servico-card [cardSimplificado]="true" [cardItem]="servico" [indice]="index"></app-servico-card>
        <hr *ngIf="!last" class="w-100 my-3 bg-secondary">
      </ng-container>
    </div>
  </div>
</ng-template>

<ng-template let-modal #mostraPacote>
  <div class="row">
    <div class="modal-header px-3 col-12 d-flex align-items-center">
      <h5 class="text-center">{{'Pacotes' | translate}}</h5>
      <i class="ms-auto me-3 fa fa-times" style="cursor: pointer;" (click)="fecharModal()"></i>
    </div>
    <div class="col-12 modal-body px-5 py-3">
      <ng-container
        *ngFor="let pacoteReserva of itemParaVisualizacao.PacoteReservas; let last = last; let index = index">
        <app-pacote-card [cardSimplificado]="true" [cardItem]="pacoteReserva"></app-pacote-card>
        <hr *ngIf="!last" class="w-100 my-3 bg-secondary">
      </ng-container>
    </div>
  </div>
</ng-template>

<ng-template let-modal #mostraBetoCarrero>
  <div class="row">
    <div class="modal-header px-3 col-12 d-flex align-items-center">
      <h5 class="text-center">{{'Ingressos Beto Carrero' | translate}}</h5>
      <i class="ms-auto me-3 fa fa-times" style="cursor: pointer;" (click)="fecharModal()"></i>
    </div>
    <div class="col-12 modal-body px-5 py-3">
      <ng-container *ngFor="let beto of itemParaVisualizacao.BetoCarreroIngressos; let last = last; let index = index">
        <app-ingressos-card [cardSimplificado]="true" [cardItem]="beto"></app-ingressos-card>
        <hr *ngIf="!last" class="w-100 my-3 bg-secondary">
      </ng-container>
    </div>
  </div>
</ng-template>